import { useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { useTheme } from "@kaltura/mediaspace-shared-styled";
import { StyledModalContent } from "./styled-components";
import { Modal } from "@kaltura/ds-react-components";
import { ExploreSideBarContent, ExploreProps } from "./ExploreSideBarContent";

/**
 * shows detailed info about selected search result - in modal or sidebar
 */
export function ExploreSideBar({ onClose, baseClassName, ...rest }: ExploreProps) {
    const theme = useTheme();
    const smScreenUp = useMediaQuery(theme.breakpoints.up("sm"));

    return (
        <>
            {!smScreenUp && (
                <Modal open={true} onClose={onClose} className={`${baseClassName}-explore-modal`}>
                    <StyledModalContent className={`${baseClassName}-explore-modal-content`}>
                        <ExploreSideBarContent
                            onClose={onClose}
                            baseClassName={baseClassName}
                            {...rest}
                        ></ExploreSideBarContent>
                    </StyledModalContent>
                </Modal>
            )}
            {smScreenUp && (
                <ExploreSideBarContent
                    baseClassName={baseClassName}
                    onClose={onClose}
                    {...rest}
                ></ExploreSideBarContent>
            )}
        </>
    );
}

export default ExploreSideBar;
